import React from 'react';

class Events extends React.Component {
    componentDidMount() {

    }

    render() {
        var images = [
            './assets/images/events/events1.jpg',
            './assets/images/events/events2.jpg'
        ]
        var list = (images.map(function (item) {
            return <img src={item} class='bigimage' />;
        }));

        var newcomplete = (
            <div class='fullwidthcontainer'>
                <div class='fullwidthcontainer'>
                    {list}
                </div>
                <div class='fullwidthcontainer'>
                    <div class='text center'>
                        &nbsp;
                    </div>
                </div>
            </div>
        );

        var disclaimer = (
            <div class='fullwidthcontainer'>
                <div class='fullwidthcontainer'>
                    <div class='disclaimer center margintopnbottom'>
                        Hier erfahren Sie alles über brandneue Events die im Augenstern stattfinden!
                    </div>
                </div>
            </div>
        );

        return disclaimer;
    }
}

export default (Events);